import React from 'react';
import { remCalc } from '../../../util/style-util';
import { makeStyles } from '@mui/styles';
import { white, resourceDarkGray } from '../../../styles/style-constants';
import { FONT_GSS_FUTURA } from 'themes/default';

type Props = {
  title: string;
  description: string;
  onClick: () => void;
};

function SupportDocumentTile(props: Props) {
  const { title, description, onClick } = props;
  const { documentTile, documentTitle, documentDescription } = useStyles();

  return (
    <div className={documentTile} onClick={onClick}>
      <div className={documentTitle}>{title}</div>
      <div className={documentDescription}>{description}</div>
    </div>
  );
}

const useStyles = makeStyles(() => {
  return {
    documentTile: {
      backgroundColor: white,
      width: '370px',
      height: remCalc(238),
      paddingLeft: remCalc(12),
      paddingRight: remCalc(12),
      paddingTop: remCalc(12),
      position: 'relative',
      boxShadow: '0px 4px 4px 0px' + resourceDarkGray,
      border: remCalc(1) + ' solid' + resourceDarkGray,
      borderRadius: remCalc(3),
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
      fontFamily: FONT_GSS_FUTURA,
      '&:hover': {
        transform: 'scale(1.05, 1.05)'
      }
    },
    documentTitle: {
      fontSize: '20px',
      fontWeight: 400,
      marginTop: '20px',
      marginLeft: '15px',
      marginRight: '15px'
    },
    documentDescription: {
      fontFamily: FONT_GSS_FUTURA,
      fontSize: '15px',
      fontWeight: 200,
      marginTop: '20px',
      marginLeft: '15px',
      marginRight: '15px'
    }
  };
});

export default SupportDocumentTile;
